export default "__VITE_ASSET__5kBc5Ji5__"